<template>
    <div class="lang">
        <span style="color:red;margin-left: -12px;" v-if="stockType == 'list'">*</span>
        <van-image
                class="stock-img"
                @click="chooseImg"
                :width="imgSize"
                :height="imgSize">
            <template v-slot:error><van-icon name="photograph" :size="imgSize/2.5" /></template>
        </van-image>
        <div v-for="(item, index) in src" :key="index" style="display: inline-block;">
            <van-image
                class="stock-img"
                @click="chooseImg"
                :width="imgSize"
                :height="imgSize"
                :src="item">
        </van-image>
        </div>
        
		<van-overlay :show="loading">
		  <div class="loading-div">
		    <van-loading color="#1989fa"></van-loading>
		  </div>
		</van-overlay>
    </div>
</template>
<script>
import { Image, Icon, Toast, Overlay, Loading } from 'vant';
export default {
    name:"ChoooseImg",
    components:{
        [Image.name]: Image,
        [Icon.name]: Icon,
        [Overlay.name]: Overlay,
        [Loading.name]: Loading
    },
    props: {
        sourceType: {
            type: Number,
            default: 0
        },
        stockType: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: '80'
        }
    },
    data(){
        return{
            imgSize: '0',
            localId: '',
            src: [],
            loading: false
        }
    },
    methods:{
		refresh() {
			this.localId = '',
			this.src = [],
			this.loading = false
		},
        chooseImg() {
            this.$wx.chooseImage({
                count: 5, // 默认9
                sizeType: ["original"], // 可以指定是原图还是压缩图，默认二者都有
                sourceType: ['album',"camera"], // 可以指定来源是相册还是相机，默认二者都有
                defaultCameraMode: "normal", //表示进入拍照界面的默认模式，目前有normal与batch两种选择，normal表示普通单拍模式，batch表示连拍模式，不传该参数则为normal模式。（注：用户进入拍照界面仍然可自由切换两种模式）
                success: (res) => {
                    this.localId = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                    console.log('获取图片id成功：'+ this.localId);
                    // andriod中localId可以作为img标签的src属性显示图片；
                    // 而在IOS中需通过上面的接口getLocalImgData获取图片base64数据，从而用于img标签的显示
                    this.showImage();
                },
                fail: function () {
                    Toast('选择图片失败');
                }
            });
        },

        showImage() {
            let that = this;
            let userAgent = navigator.userAgent.toLowerCase();
            console.log('userAgent', userAgent)
            // iphone 多做一步操作
            if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1){
                console.log('上传文件长度',this.localId.length)
                for(let i =0 ; i < this.localId.length; i++) {
                    this.$wx.getLocalImgData({
                        localId: this.localId[i], // 图片的localID
                        success: (res) => {
                            console.log('----show image', res);
                            that.src.push(res.localData);
                            console.log('----图片长度', this.src)
                            // 上传图片
                            this.upload(i);
                        },
                        fail: function () {
                            Toast('转换图片失败');
                        }
                    });
                } 
            }
            // 安卓手机直接显示预览图
            else {
                this.src = this.localId;
                console.log('图片列表', this.src)
                for(let i =0 ; i < this.localId.length;i++) {
                    // 上传图片
                    this.upload(i);
                }
            }

        },
        upload(i) {
			this.loading = true
            this.$wx.uploadImage({
                localId: this.localId[i], // 需要上传的图片的本地ID，由chooseImage接口获得
                isShowProgressTips: 0, // 默认为1，显示进度提示
                success: (res) => {
                    // 返回图片的服务器端ID
					this.loading = false
                    console.log('我要回传照片', res.serverId)
                    this.$emit('finish', res.serverId);
                },
                fail: (res) => {
					this.loading = false
                    console.log('upload fail', res)
                    Toast('图片上传微信服务器失败');
                }
            });
        }
    },
    created() {
        this.imgSize = this.size;
    }
}
</script>
<style lang="less" scoped>
  .loading-div {
    text-align: center;
    margin-top: 45vh;
  }
</style>
